export default __webpack_public_path__ + "static/media/shoestable.28d5a554.jpg";